export default __webpack_public_path__ + "static/N0160-124940b3e1c1827d32d04adb6f0854a3.png";